// @flow
import { handleActions } from "redux-actions";
import { List } from "immutable";
import { LanguageSettings } from "../records/userSettings.record";
import Record from "../flow/Record";
import { setupRequest } from "./request.reducer";
import { RequestState } from "../records/request.record";
import {
    closeProfile,
    editProfile as editProfileAction,
    openProfile,
    saveProfile,
    saveProfileFailure,
    saveProfileSuccess
} from "../actions/editProfile.actions";

const editProfileRequest = setupRequest("editProfileRequest");

export class EditProfile extends Record({
    displayName: "",
    emailNotifications: false,
    languages: List(),
    editProfileRequest: new RequestState(),
    open: false
}) {
    displayName: string;
    emailNotifications: boolean;
    languages: List<LanguageSettings>;
    editProfileRequest: RequestState;
    open: boolean;
}

const editProfile = handleActions(
    {
        [openProfile](
            state,
            { payload: { displayName, languages, emailNotifications } }
        ) {
            return state.merge({
                displayName,
                languages,
                emailNotifications,
                open: true
            });
        },
        [editProfileAction](state, { payload }) {
            return state.merge(payload);
        },
        [closeProfile](state) {
            return state.set("open", false);
        },
        [saveProfile]: editProfileRequest.start,
        [saveProfileSuccess](state) {
            return editProfileRequest.success(state).set("open", false);
        },
        [saveProfileFailure]: editProfileRequest.failure
    },
    new EditProfile()
);

export default editProfile;



// WEBPACK FOOTER //
// ./src/reducers/editProfile.reducer.js